export default __webpack_public_path__ + "static/direct-delivery-211059ef4c5ca963348d0bbf3a072195.png";